<template>
  <HeaderWarningPanel :visible="daysLeft !== null && daysLeft >= 0 && daysLeft <= 3"
                       :link-to="rights.includes('billing') && canProlong ? '/billing' : null"
                       :link-text="$t('prolong')">
    {{ $tc('tariff_payment_expires_in_days', daysLeft, { day: daysLeft }) }}.
  </HeaderWarningPanel>
</template>

<script>

import {mapState} from "vuex"
import moment from "moment-timezone"
import HeaderWarningPanel from "@/components/parts/general/HeaderWarningPanel.vue"

export default {
  name: "TariffEndsHeader",
  components: {
    HeaderWarningPanel
  },
  computed: {
    ...mapState({
      clinic: state => state.auth.clinic,
      rights: state => state.auth.rights,
    }),
    paidTill() {
      if(!this.clinic || !this.clinic.clinic_tariff) return null
      return this.clinic.clinic_tariff.paid_till
    },
    canProlong() {
      return !this.clinic?.clinic_tariff?.tariff?.billing_turned_off
    },
    daysLeft() {
      if(!this.paidTill) return null
      let now = moment()
      return Math.ceil(moment(this.paidTill).diff(now, 'days', true))
    }
  }
}
</script>
